import React from "react";
import { Navigate } from "react-router-dom";
import V2Layout from "./views/v2/V2Layout";
import DashboardV2 from "./views/v2/Dashboard";
import ActionsList from "./views/v2/ActionsList";
import ActionsSurveys from "./views/v2/ActionsSurveys";
import ActionsReviews from "./views/v2/ActionsReviews";
import ActionsWater from "./views/v2/ActionsWater";
import ActionsCleaning from "./views/v2/ActionsCleaning";
import RewardsList from "./views/v2/RewardsList";
import RewardsSales from "./views/v2/RewardsSales";
import RewardsDonations from "./views/v2/RewardsDonations";
import GreenMilesV2 from "./views/v2/GreenMilesV2";
import PageAccessGuard from "./components/PageAccessGuard";
import { HotelContext } from "./context/HotelContext";

// Composant pour gérer le selectedHotelId et le passer au Dashboard
// Synchronise avec le HotelContext pour que le choix d'hôtel soit utilisé pour les notifications et autres données
const DashboardWithHotel = () => {
  const { hId, sethId } = React.useContext(HotelContext);
  const [selectedHotelId, setSelectedHotelId] = React.useState(() => hId || localStorage.getItem("hId") || null);

  // Synchroniser avec le contexte quand il change
  React.useEffect(() => {
    if (hId && hId !== selectedHotelId) {
      setSelectedHotelId(hId);
    }
  }, [hId, selectedHotelId]);

  const handleHotelChange = (hotelId) => {
    setSelectedHotelId(hotelId);
    // Mettre à jour le contexte pour que toutes les pages utilisent cet hôtel
    sethId(hotelId);
    if (hotelId) {
      localStorage.setItem("hId", hotelId);
    } else {
      localStorage.removeItem("hId");
    }
  };

  return <DashboardV2 selectedHotelId={selectedHotelId} onHotelChange={handleHotelChange} />;
};

const routesV2 = [
  {
    path: "/hotel/lunishower/v2",
    element: <V2Layout />,
    children: [
      {
        index: true,
        element: <Navigate to="/hotel/lunishower/v2/dashboard" replace />,
      },
      {
        path: "dashboard",
        element: (
          <PageAccessGuard pageName="dashboard-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <DashboardWithHotel />
          </PageAccessGuard>
        ),
      },
      {
        path: "greenmiles",
        element: (
          <PageAccessGuard pageName="greenmiles-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <GreenMilesV2 />
          </PageAccessGuard>
        ),
      },
      {
        path: "actions-list",
        element: (
          <PageAccessGuard pageName="actions-list-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <ActionsList />
          </PageAccessGuard>
        ),
      },
      {
        path: "actions-surveys",
        element: (
          <PageAccessGuard pageName="actions-surveys-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <ActionsSurveys />
          </PageAccessGuard>
        ),
      },
      {
        path: "actions-reviews",
        element: (
          <PageAccessGuard pageName="actions-reviews-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <ActionsReviews />
          </PageAccessGuard>
        ),
      },
      {
        path: "actions-water",
        element: (
          <PageAccessGuard pageName="actions-water-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <ActionsWater />
          </PageAccessGuard>
        ),
      },
      {
        path: "actions-cleaning",
        element: (
          <PageAccessGuard pageName="actions-cleaning-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <ActionsCleaning />
          </PageAccessGuard>
        ),
      },
      {
        path: "rewards-list",
        element: (
          <PageAccessGuard pageName="rewards-list-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <RewardsList />
          </PageAccessGuard>
        ),
      },
      {
        path: "rewards-sales",
        element: (
          <PageAccessGuard pageName="rewards-sales-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <RewardsSales />
          </PageAccessGuard>
        ),
      },
      {
        path: "rewards-donations",
        element: (
          <PageAccessGuard pageName="rewards-donations-v2" requireHotel={true} bypass={false} fallbackPath="/user/hotels">
            <RewardsDonations />
          </PageAccessGuard>
        ),
      },
    ],
  },
];

export default routesV2;
